<cmps-dialog>
    <cmps-dialog-header>
        <div
            class="cmps-cdk-font-bold cmps-cdk-text-center cmps-teamscall-call-dialog--font1"
        >
            {{ _i18n._9989_PLACING_CALL | translate }}
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body>
        <div class="cmps-cdk-font-bold cmps-cdk-pb-0dot5">
            <div
                class="cmps-cdk-d-flex cmps-cdk-justify-content-center cmps-cdk-p-1dot25"
            >
                <div class="cmps-teamscall-call-dialog--dot-flashing"></div>
            </div>
            <div
                class="cmps-cdk-text-center cmps-teamscall-call-dialog--font2"
                [class.cmps-cdk-pb-1dot25]="_hasTimeout || _hasError"
                *ngIf="_statusStr"
            >
                {{ _statusStr | translate }}
            </div>
            <div
                class="cmps-cdk-d-flex cmps-cdk-justify-content-center"
                *ngIf="_hasTimeout || _hasError"
            >
                <ng-container *ngIf="_hasTimeout">
                    <!-- backend will try to end the call on its own. msft teams will also try -->
                    <button
                        class="cmps-outline-button--no-bg cmps-cdk-mx-0dot5"
                        cmpsOutlineButton
                        (click)="_dialogRef?.close()"
                    >
                        <span cmpsOutlineButtonLabel>{{
                            _i18n._11049_END_THE_CALL | translate
                        }}</span>
                    </button>
                    <button
                        class="cmps-cdk-mx-0dot5"
                        cmpsButton
                        (click)="_onRetryClick()"
                    >
                        <span cmpsButtonLabel>{{
                            _i18n._11050_RETRY | translate
                        }}</span>
                    </button>
                </ng-container>
                <ng-container *ngIf="_hasError">
                    <button
                        cmpsButton
                        (click)="_dialogRef?.close()"
                    >
                        <span cmpsButtonLabel>{{
                            _i18n._9425_OK | translate
                        }}</span>
                    </button>
                </ng-container>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
